
import { Component, Prop, Vue } from 'vue-property-decorator';
import PageService from '@/utils/PageService';

// Svg
import ArrowBackSVG from '@/assets/arrow_back.svg';

// Components
import VButton from '@/components/VButton/VButton.vue';
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';

@Component({
    components: {
        ArrowBackSVG,

        VButton,
        VButtonIcon,
    },
})
export default class VPageTitle extends Vue {
    @Prop({ type: Boolean, default: false })
    public hasBackButton!: boolean;

    @Prop({ type: Boolean, default: false })
    public secondary!: boolean;

    @Prop({ type: Function, default: null })
    public backAction?: () => void;

    get currentPageTitle() {
        return PageService.getPageTitle(this.$route);
    }

    public invokeAction() {
        if (this.backAction) this.backAction();
        else this.$router.back();
    }
}
